export default [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: resolve => require(['@/views/login.vue'], resolve),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/main',
    component: resolve => require(['@/components/layout/index'], resolve),
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        component: resolve => require(['@/views/home.vue'], resolve),
        meta: {
          title: '首页'
        }
      },
      //案例
      {
        path: '/case/',
        name: 'case',
        component: resolve => require(['@/views/case/index.vue'], resolve),
        meta: {
          title: '案例'
        }
      },
      {
        path: '/case/allscene',
        name: 'allscene',
        component: resolve => require(['@/views/case/allscene.vue'], resolve),
        meta: {
          title: '金融全场景'
        }
      },
      //案例选择
      {
        path: '/case/caseselect',
        name: 'caseselect',
        component: resolve => require(['@/views/case/caseselect.vue'], resolve),
        meta: {
          title: '案例选择'
        }
      },
      //案例操作说明
      {
        path: '/case/casedescription',
        name: 'casedescription',
        component: resolve => require(['@/views/case/casedescription.vue'], resolve),
        meta: {
          title: '案例说明'
        }
      },
      //案例前置学习
      {
        path: '/case/precasestudy',
        name: 'precasestudy',
        component: resolve => require(['@/views/case/precasestudy.vue'], resolve),
        meta: {
          title: '案例前置学习'
        }
      },
      //智能客服
      {
        path: '/case/zhinengkefu',
        name: 'zhinengkefu',
        component: resolve => require(['@/views/case/zhinengkefu/index.vue'], resolve),
        meta: {
          title: '案例前置学习'
        }
      },
      //投研报告
      {
        path: '/case/touyanbaogao',
        name: 'touyanbaogao',
        component: resolve => require(['@/views/case/touyanbaogao/index.vue'], resolve),
        meta: {
          title: '投研报告'
        }
      },
      //智能投研
      {
        path: '/case/zhinengtouyan',
        name: 'zhinengtouyan',
        component: resolve => require(['@/views/case/zhinengtouyan/index.vue'], resolve),
        meta: {
          title: '智能投研'
        }
      },
      //商务数据分析智能体
      {
        path: '/case/shangwushuju',
        name: 'shangwushuju',
        component: resolve => require(['@/views/case/shangwushuju/index.vue'], resolve),
        meta: {
          title: '商务数据分析智能体'
        }
      },
      // 商务数据分析智能体-下一步
      {
        path: '/case/shangwushujupage',
        name: 'shangwushujupage',
        component: resolve => require(['@/views/case/shangwushuju/shangwushujupage.vue'], resolve),
        meta: {
          title: '商务数据分析智能体-操作'
        }
      },
      //贷款额度预测智能体
      {
        path: '/case/xinyongfengxian',
        name: 'xinyongfengxian',
        component: resolve => require(['@/views/case/xinyongfengxian/index.vue'], resolve),
        meta: {
          title: '贷款额度预测智能体'
        }
      },
      // 反欺诈
      {
        path: '/case/fanqizha',
        name: 'fanqizha',
        component: resolve => require(['@/views/case/fanqizha/index.vue'], resolve),
        meta: {
          title: '反欺诈'
        }
      },
      //DYGPT
      {
        path: '/case/dygpt',
        name: 'dygpt',
        component: resolve => require(['@/views/case/dygpt.vue'], resolve),
        meta: {
          title: 'DYGPT'
        }
      },
      //工作流
      {
        path: '/case/workflow',
        name: 'workflow',
        component: resolve => require(['@/views/case/workflow.vue'], resolve),
        meta: {
          title: 'workflow'
        }
      },
      //场景体验
      {
        path: '/sceneExperience',
        name: 'sceneExperience',
        component: resolve => require(['@/views/sceneExperience/index.vue'], resolve),
        meta: {
          title: '场景体验'
        }
      },
      //资料库 
      {
        path: '/dataBase',
        name: 'database',
        component: resolve => require(['@/views/dataBase/index.vue'], resolve),
        meta: {
          title: '资料库'
        }
      },
      //理论入口
      {
        path: '/theoryEntrance',
        name: 'theoryEntrance',
        component: resolve => require(['@/views/theory/theoryEntrance.vue'], resolve),
        meta: {
          title: '理论'
        }
      },
      //理论练习列表
      {
        path: '/theoryPracticeList',
        name: 'theoryPracticeList',
        component: resolve => require(['@/views/theory/theoryPracticeList.vue'], resolve),
        meta: {
          title: '理论练习'
        }
      },
      //理论考试列表
      {
        path: '/theoryTestList',
        name: 'theoryTestList',
        component: resolve => require(['@/views/theory/theoryTestList'], resolve),
        meta: {
          title: '理论考试'
        }
      },
      //做题历史 
      {
        path: '/theoryHistoryList',
        name: 'theoryHistoryList',
        component: resolve => require(['@/views/theory/theoryHistoryList'], resolve),
        meta: {
          title: '做题历史'
        }
      },
      //理论练习
      {
        path: '/theoryPractice',
        name: 'theoryPractice',
        component: resolve => require(['@/views/theory/index.vue'], resolve),
        meta: {
          title: '理论练习-做题'
        }
      },
      //理论考试
      {
        path: '/theoryTest',
        name: 'theoryTest',
        component: resolve => require(['@/views/theory/index'], resolve),
        meta: {
          title: '理论考试-做题'
        }
      },
      //课程中心
      {
        path: '/curriculum',
        name: 'curriculum',
        component: resolve => require(['@/views/curriculum/index.vue'], resolve),
        meta: {
          title: '课程中心'
        }
      },
      //课程学习
      {
        path: '/curriculumStudy',
        name: 'curriculum',
        component: resolve => require(['@/views/curriculum/curriculumStudy.vue'], resolve),
        meta: {
          title: '课程学习'
        }
      },
      //执行结果记录（用于记录组件模式编译结果）
      {
        path: '/resultRecording',
        name: 'resultRecording',
        component: resolve => require(['@/views/resultRecording.vue'], resolve),
        meta: {
          title: '执行结果记录'
        }
      },
    ]
  }
]
